import { useEffect, useState } from "react";
import { BLITZ_CI_AUTH } from "./constants";
import { jwtDecode } from "jwt-decode";
import { defaultOrg } from "../api/data/orgs";
import Api from "../api";
import { defaultUser } from "../api/data/users";

function useAccessToken() {
  const [accessToken, setAccessToken] = useState("");
  const [userData, setUserData] = useState(defaultUser);
  const [organizationData, setOrganizationData] = useState(defaultOrg);
  const [decodedAccessToken, setDecodedAccessToken] = useState({});

  const getUserData = async (userID) => {
    const response = await Api.DataService.Users.getUserData(userID);
    if (!response.success) return;

    setUserData(response.data);
    return response.data;
  };

  const getOrgData = async () => {
    if (Object.keys(decodedAccessToken).length === 0) return;

    const user = await getUserData(decodedAccessToken.user_id);

    if (!user) return;

    const response = await Api.DataService.Orgs.getOrgData(user.orgID);
    if (!response.success) return;

    setOrganizationData(response.data);
  };

  useEffect(() => {
    const token = sessionStorage.getItem(BLITZ_CI_AUTH);
    if (!token) {
        setAccessToken("");
        return;
    }

    setAccessToken(token);
    const decoded = jwtDecode(token);
    setDecodedAccessToken(decoded);
  }, []);

  useEffect(() => {
    getOrgData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decodedAccessToken])

  return { accessToken, decodedAccessToken, userData, organizationData };
};

export default useAccessToken;